"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.nav.dashboard': 'Dashboard',
    'socialMediaPlan.nav.channels': 'Canali',
    'socialMediaPlan.nav.analytics': 'Analytics',
};
